import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { APIV2 } from "services/ApiServiceV2";
import AsyncStorage from "@react-native-async-storage/async-storage";

export const getConfig = createAsyncThunk("utils/getConfig", async (arg, thunkAPI) => {
    let persist = await AsyncStorage.getItem("persist:root");
    const data = await APIV2(`user/v1/user-profile/homepage/config`, "GET", {}, "JAVA")
        .then((res) => {
            return { ...res };
        })
        .catch((err) => {
            return err;
        });

    return { persist, data };
});

export const getCountry = createAsyncThunk("utils/getCountry", async (arg, thunkAPI) => {
    const data = await APIV2(`user/v1/user-profile/homepage/fetchCountry`, "GET", {}, "JAVA")
        .then((res) => {
            return { ...res };
        })
        .catch((err) => {
            return err;
        });

    return { data };
});



let initialState = {
    guestUserId: null,
    countries: [],
    country:undefined,
    currency: 'USD ($)',
    countrySymbol: '$',

};

export const storedUtilsSlice = createSlice({ 
    name: "storedUtils",
    initialState,
    reducers: {
        resetStoredUtilsSlice: (state) => {
            state.guestUserId = null;
        },
        setGuestUserId: (state, action) => {
            state.guestUserId = action.payload;
        },
        setCountries: (state, action) => {

            state.countries = action.payload;
        },
        setCountry: (state, action) => {
            state.country = action.payload;
            AsyncStorage.setItem("country", action.payload.name);
        },
        setCurrency: (state, action) => {
            state.currency = action.payload;
            const [currency, symbol = '$'] = action.payload.split(' ');
            state.countrySymbol = symbol.replace(/[()]/g, '');
            AsyncStorage.setItem("currency", action.payload);
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getConfig.pending, (state, action) => {})
            .addCase(getConfig.fulfilled, (state, action) => {
                if (action?.payload?.data?.data?.configs && Array.isArray(action?.payload?.data?.data?.configs)) {
                    state.appConfig = action.payload?.data?.configs;
                    let guestUserId;
                    try {
                        guestUserId = JSON.parse(JSON.parse(action?.payload?.persist)?.UtilsReducer)?.guestUserId;
                    } catch (err) {}
                    if (!state.guestUserId && !guestUserId) {
                        state.guestUserId = action?.payload?.data?.data?.anonymousUserId;
                    } else if (!state.guestUserId && guestUserId) {
                        state.guestUserId = guestUserId;
                    }
                }
            })
            .addCase(getConfig.rejected, (state, action) => {
                console.log("getConfig api error", action?.payload);
            })

    },
});

export const { resetStoredUtilsSlice, setGuestUserId, setCountries, setCountry, setCurrency  } = storedUtilsSlice.actions;

export default storedUtilsSlice.reducer;
